module.exports = __webpack_public_path__ + "static/img/11areaB_10.9ee9588.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/11areaB_10.png
// module id = 1090
// module chunks = 1